import { create } from 'zustand';

import { Product } from '@/types';

export interface AppStore {
  selectedCurrency: string;
  setSelectedCurrency: (currency: string) => void;
  selectedSector: string;
  setSelectedSector: (sector: string) => void;
  selectedRating: string;
  setSelectedRating: (rating: string) => void;
  lastRefreshed: string;
  setLastRefreshed: (lastRefreshed: string) => void;
  selectedProduct: Product | undefined;
  setSelectedProduct: (product: Product | undefined) => void;
  token: string;
  setToken: (token: string) => void;
  progress: number;
  setProgress: (progress: number) => void;
}

export const useAppStore = create<AppStore>((set) => ({
  selectedCurrency: 'GBP',
  setSelectedCurrency: (currency: string) =>
    set({ selectedCurrency: currency, selectedProduct: undefined }),
  selectedSector: 'All Sectors',
  setSelectedSector: (sector: string) => set({ selectedSector: sector }),
  selectedRating: 'All Products',
  setSelectedRating: (rating: string) => set({ selectedRating: rating }),
  lastRefreshed: new Date().toLocaleString(),
  setLastRefreshed: (lastRefreshed: string) => set({ lastRefreshed }),
  selectedProduct: undefined,
  setSelectedProduct: (product: Product | undefined) =>
    set({ selectedProduct: product }),
  token: '',
  setToken: (token: string) => set({ token }),
  progress: 0,
  setProgress: (progress: number) => set({ progress }),
}));
